import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { ThemeProvider } from '@/components/theme-provider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import router from '@/router'
import { PermissionsProvider } from './context/permissions'
import { UserProvider } from './context/UserContext'
import { WebSocketProvider } from './context/WebSocketContext'
import { NotificationsProvider } from './context/NotificationsContext'
import '@/configs/i18n'
import '@/index.css'
import '@/configs/sentry'
import { TooltipProvider } from './components/ui/tooltip'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
})

// Stale-chunk (dynamic import) failures are handled by the router's errorElement
// (see src/pages/errors/general-error.tsx), which reloads only after the router
// has committed the target location. Reloading here on 'vite:preloadError' would
// fire mid-navigation while the URL still points at the old page, sending the
// user back to the page they were leaving instead of the one they navigated to.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PermissionsProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme='dark' storageKey='vite-ui-theme'>
          <Provider store={store}>
            <WebSocketProvider>
              <NotificationsProvider>
                <UserProvider>
                  <TooltipProvider>
                    <RouterProvider router={router} />
                  </TooltipProvider>
                </UserProvider>
              </NotificationsProvider>
            </WebSocketProvider>
          </Provider>
          <Toaster />
        </ThemeProvider>
      </QueryClientProvider>
    </PermissionsProvider>
  </StrictMode>
)
